import { render, staticRenderFns } from "./Homemake.vue?vue&type=template&id=9a2d5bbe&scoped=true&"
import script from "./Homemake.vue?vue&type=script&lang=js&"
export * from "./Homemake.vue?vue&type=script&lang=js&"
import style0 from "./Homemake.vue?vue&type=style&index=0&id=9a2d5bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2d5bbe",
  null
  
)

export default component.exports